import { render, staticRenderFns } from "./BackCardlist.vue?vue&type=template&id=9d37dd4c&scoped=true&"
import script from "./BackCardlist.vue?vue&type=script&lang=js&"
export * from "./BackCardlist.vue?vue&type=script&lang=js&"
import style0 from "./BackCardlist.vue?vue&type=style&index=0&id=9d37dd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d37dd4c",
  null
  
)

export default component.exports